import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LicenseNamePipe } from './license-name.pipe';

@NgModule({
    declarations: [LicenseNamePipe],
    imports: [CommonModule],
    exports: [LicenseNamePipe],
})
export class LicenseNamePipeModule {}
